import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import logo from "../../assets/Logos/logo.png";
import "./Header.scss";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { t, i18n } = useTranslation();
  const location = useLocation();

  const lang = i18n.language || "en"; // current language

  const toggleMenu = () => setMenuOpen(!menuOpen);

  // Toggle language and redirect to same page
  const toggleLanguage = () => {
    const newLang = lang === "en" ? "is" : "en";
    i18n.changeLanguage(newLang);
    // Replace current language code in URL
    const newPath = location.pathname.replace(`/${lang}`, `/${newLang}`);
    window.location.pathname = newPath;
  };

  const base = `/${lang}`;

  return (
    <header className="header">
      <nav className="nav">
        <Link to={base}>
          <div className="nav__left">
            <img src={logo} className="nav__logo" alt="Moss Media logo" />
          </div>
        </Link>

        <div
          className={`nav__burger ${menuOpen ? "nav__burger--open" : ""}`}
          onClick={toggleMenu}
        >
          <span className="nav__burger-line"></span>
          <span className="nav__burger-line"></span>
          <span className="nav__burger-line"></span>
        </div>

        <div className={`nav__menu ${menuOpen ? "nav__menu--open" : ""}`}>
          <ul className="nav__list">
            <li className="nav__item">
              <Link to={`${base}/portfolio`} className="nav__link">
                {t("nav.portfolio")}
              </Link>
            </li>
            <li className="nav__item">
              <Link to={`${base}/services`} className="nav__link">
                {t("nav.services")}
              </Link>
            </li>
            <li className="nav__item">
              <Link to={`${base}/about`} className="nav__link">
                {t("nav.about")}
              </Link>
            </li>
            <li className="nav__item">
              <Link to={`${base}/blog`} className="nav__link">
                {t("nav.blog")}
              </Link>
            </li>
            <li className="nav__item--mobile">
              <Link to={`${base}/contact`} className="nav__link">
                {t("nav.contact")}
              </Link>
            </li>
          </ul>

          <Link to={`${base}/contact`}>
            <button className="nav__cta">{t("nav.cta")}</button>
          </Link>

          {/* Language toggle */}
          <button className="nav__lang-toggle" onClick={toggleLanguage}>
            {lang === "en" ? "IS" : "EN"}
          </button>
        </div>
      </nav>
    </header>
  );
};

export default Header;
